
/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */
// 正式
// export const PAGE_NAME = "临港新片区公租房";  //all title
// export const PAGE_COMPANY = "上海临港新城公共租赁住房运营有限公司";
// export const PAGE_LINK = "https://lingangbzf.com";
// 测试
export const PAGE_NAME = "网签平台";  //all title
export const PAGE_COMPANY = "网签平台";
export const PAGE_LINK = "";

export const USERVALIDTIME = 30 * 60 * 1000;   //过期时间
export const sendNationCaptchaName = 'publicHousing_lg_ci_verifycode'; //拓希短信
export const companyInfo = {
    companyCode:'028',
    companyName:'上海临港新城公共租赁住房运营有限公司'
};
// export const NODE_API = process.env.NODE_ENV== 'production'?'/api/oms':"/api"
// export const NODE_API1 = process.env.NODE_ENV== 'production'?'/api1/oms':"/api1"
// export const NODE_API2 = process.env.NODE_ENV== 'production'?'/api2/oms':"/api2"
// export const NODE_API3 = process.env.NODE_ENV== 'production'?'/api3/oms':"/api3"
export const NODE_API = "/api/oms"
export const NODE_API1 = "/api1/oms"
export const NODE_API2 = "/api2/oms"
export const NODE_API3 = "/api3/oms"



export const  FILEACTIONURL= '/group1/upload' //上传总文件的action(本地上传)
